"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var routes_1 = require("../config/routes");
var ConfigContext_1 = require("../contexts/ConfigContext");
var utils_1 = require("../libs/utils");
var cache_1 = require("../libs/cache");
var changelogs_1 = require("../models/changelogs");
var Label_1 = require("./Label");
var Reaction_1 = require("./Reaction");
var TaggedPost_1 = require("./TaggedPost");
var findLocalChangelog = function (id) {
    var localData = cache_1.getLocalHashData(routes_1.GET_CHANGELOGS);
    var index = localData.changelogs.findIndex(function (c) { return +c.id === +id; });
    return { index: index, changelog: localData.changelogs[index], data: localData };
};
var updateLocalChangelog = function (newChangelog) {
    var _a = findLocalChangelog(newChangelog.id), index = _a.index, data = _a.data;
    var newLocalData = Object.assign({}, data);
    if (newChangelog.feature_requests)
        newLocalData.changelogs[index].feature_requests =
            newChangelog.feature_requests;
    if (newChangelog.user)
        newLocalData.changelogs[index].user = newChangelog.user;
    return cache_1.updateLocalHashData(routes_1.GET_CHANGELOGS, newLocalData);
};
var SingleChangelog = function (props) {
    var stageProps = props.stageProps, config = props.config;
    var translations = hooks_1.useContext(ConfigContext_1.default).translations;
    var _a = hooks_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = hooks_1.useState(null), error = _b[0], setError = _b[1];
    var _c = hooks_1.useState(null), changelog = _c[0], setChangelog = _c[1];
    var mountedRef = hooks_1.useRef(true);
    var fetchChangelog = function () {
        if (!mountedRef.current)
            return null;
        setLoading(true);
        return changelogs_1.getChangelog(config.token, stageProps.id.toString())
            .then(function (data) {
            setChangelog(data);
            if (utils_1.isLocalStorageAvailable())
                updateLocalChangelog(data);
        })
            .catch(function (err) { return setError(err.message); })
            .finally(function () { return setLoading(false); });
    };
    hooks_1.useEffect(function () {
        if (utils_1.isLocalStorageAvailable())
            setChangelog(findLocalChangelog(stageProps.id).changelog);
        fetchChangelog();
        return function () {
            mountedRef.current = false;
        };
    }, []);
    var renderLabel = function (label, index) { return (preact_1.h(Label_1.default, tslib_1.__assign({ key: index }, label))); };
    var renderReaction = function (reaction, index) { return (preact_1.h(Reaction_1.default, tslib_1.__assign({ key: index }, reaction))); };
    var renderTaggedFeatureRequest = function (featureRequest, index) { return preact_1.h(TaggedPost_1.default, { key: index, featureRequest: featureRequest }); };
    var renderTaggedFeatureRequests = function () {
        if (changelog.feature_requests && changelog.feature_requests.length) {
            return (preact_1.h(preact_1.Fragment, null,
                preact_1.h("h2", { className: "pt-3 mt-3 mb-4 text-xs font-semibold text-gray-900 border-t border-gray-100" }, translations.taggedPostsTitle || "Related Posts"),
                changelog.feature_requests.map(renderTaggedFeatureRequest)));
        }
    };
    if (!changelog && loading) {
        return (preact_1.h("div", { className: "flex items-center justify-center h-full" },
            preact_1.h("svg", { class: "animate-spin h-5 w-5 text-primary", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
                preact_1.h("circle", { class: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", "stroke-width": "4" }),
                preact_1.h("path", { class: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))));
    }
    if (error)
        return preact_1.h("div", { className: "my-10 text-center text-red-700" }, error);
    if (changelog) {
        return (preact_1.h("div", { className: "p-3 space-y-3", key: changelog.id },
            preact_1.h("div", { className: "prose-xs prose prose-blue break-words max-w-none" },
                preact_1.h("a", { href: changelog.url, target: "_blank", className: "!no-underline hover:text-primary" },
                    preact_1.h("h2", { className: "!mt-0 hover:text-primary" }, changelog.title)),
                preact_1.h("div", { dangerouslySetInnerHTML: { __html: changelog.description_html } })),
            preact_1.h("div", null, changelog.labels.map(renderLabel)),
            preact_1.h("div", { className: "flex flex-wrap items-center justify-start" }, changelog.reactions.map(renderReaction)),
            preact_1.h("p", { className: "text-xs text-gray-500" },
                "Published ",
                preact_1.h("span", { className: "lowercase" }, changelog.published_at)),
            renderTaggedFeatureRequests()));
    }
};
exports.default = SingleChangelog;
